import React, { useState } from "react";

const FAQ = () => {
  const topics = [
    {
      title: "What makes your coffee different?",
      content:
        "What makes our coffee truly different is its origin – the breathtaking Araku Valley. Nestled in the Eastern Ghats, Araku’s high elevation, mineral-rich soil, and cool climate create the perfect terroir for cultivating exceptional Arabica beans. But beyond the geography, it's the people that make it special — indigenous tribal communities practice biodynamic, organic farming with a deep-rooted connection to the land. Every bean is handpicked, sun-dried, and roasted in small batches to preserve its delicate notes of fruit, florals, and a smooth, rich body. This isn’t just coffee — it’s a story of tradition, sustainability, and a cup full of character.",
    },
    {
      title: "How should I store my coffee beans?",
      content:
        "Keep your coffee beans in an airtight container, in a cool, dry place—away from direct sunlight, heat, and moisture. Avoid storing it in the fridge or freezer for best taste.",
    },
    {
      title: "Are your beans organic and certified ?",
      content:
        "Yes! We proudly offer organic and certified beans from coffee board of India, ensuring sustainability and support for farming communities.",
    },
    {
      title: "What is Vanmaya?",
      content:
      "Each coffee bean begins its journey as a green bean, gently nurtured by the skilled hands of tribal women whose wisdom spans generations. Handpicked from the lush, misty slopes of Araku, these beans are more than a crop — they are a testament to a deep connection with the earth and its rhythms. Every harvest of green beans carries the essence of nature, culture, and quiet resilience. In every cup, you taste the care, the story, and the spirit of those who grew it."    },
    {
      title: "How can I contact customer support?",
      content:
        "You can call us at +91 9011211111 / +91 2029911111 also you can email us at connect@magicroastqoffee.com or reach out via our Contact Us page. We usually reply within 24 hours.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const containerStyle = {
    background:  "rgb(232, 240, 238)",   //'linear-gradient(135deg, #f9f0db 0%, #e6d7b8 100%)'
    padding: "40px",
    fontFamily: "'Courier New', Courier, monospace",
  };

  const itemStyle = {
    marginBottom: "30px",
    cursor: "pointer",
    fontSize: "20px",
    color: "#6B4226",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  };

  const symbolStyle = {
    marginRight: "10px",
    fontSize: "24px",
  };

  const contentStyle = {
    marginTop: "10px",
    fontSize: "16px",
    color: "rgb(93, 64, 55)",
    lineHeight: "1.6",
    transition: "max-height 5s ease",
    marginBottom:"20px"
  };

  const toggleItem = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div style={containerStyle}>
      <h1 style={{display:"flex",alignItems:"center",justifyContent:"center",marginBottom:"50px",color:"#6B4226"}}>Frequently Asked Questions</h1>
      {topics.map((topic, index) => (
        <div key={index}>
          <div style={itemStyle} onClick={() => toggleItem(index)}>
            <span style={symbolStyle}>{activeIndex === index ? "−" : "+"}</span>
            {topic.title}
          </div>
          {activeIndex === index && (
            <div style={contentStyle}>{topic.content}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
